require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-microsoft-studios-project-spark-leads-the-way-for-user-created-adventure-games.json") })
        }
      }, "path---blog-microsoft-studios-project-spark-leads-the-way-for-user-created-adventure-games");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-microsoft-studios-project-spark-leads-the-way-for-user-created-adventure-games!./.cache/json/blog-microsoft-studios-project-spark-leads-the-way-for-user-created-adventure-games.json
// module id = 984
// module chunks = 231608221292675